const COLORS = {
  error: {
    border: '#ff3935',
    text: '#ff3935'
  },
  warning: {
    border: 'rgb(255, 150, 0)',
    text: 'rgb(255, 150, 0)'
  },
  active: {
    border: 'rgb(243, 112, 33)',
    text: 'rgb(243, 112, 33)'
  },
  light: {
    border: 'rgb(238, 238, 238)',
    text: 'rgb(53, 46, 39)'
  },
  dark: {
    border: 'rgb(238, 238, 238)',
    text: 'rgb(53, 46, 39)'
  }
};
export default COLORS;